export enum ListingTaskResult {
  incomplete = 'incomplete',
  success = 'success',
  failed = 'failed',
}

export interface ListingTaskProps {
  id: string
  result: ListingTaskResult
  createdAt: string
  updatedAt: string
  successData?: {
    id?: string
    status?: string
    accountId?: string
    listingUrl?: string
    locationId?: string
    publisherId?: string
    screenshotUrl?: string
    alternateBrands?: string[]
  }
}
